import { api } from "./api";

export const akilChat = (payload) =>
    api.post("/v1/admin/akil/chat/", payload, { timeout: 120000 }).then((r) => r.data);

export const akilEvrakAnaliz = (file, belgeTipi = "otomatik") => {
    const fd = new FormData();
    fd.append("file", file);
    if (belgeTipi) fd.append("belge_tipi", belgeTipi);
    return api.post("/v1/admin/akil/evrak-analiz/", fd, { timeout: 300000 }).then((r) => r.data);
};

export const akilOcrDegerKaybi = (file, belgeTipi = "hasar_faturasi") => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("belge_tipi", belgeTipi);
    return api
        .post("/v1/admin/akil/ocr-deger-kaybi/", fd, {
            timeout: 300000,
            transformRequest: [(data, headers) => {
                if (headers) delete headers["Content-Type"];
                return data;
            }],
        })
        .then((r) => r.data);
};

export const akilGunlukBrifing = () =>
    api.get("/v1/admin/akil/gunluk-brifing/", { timeout: 120000 }).then((r) => r.data);

export const akilMerkezDashboard = (gun = 30) =>
    api.get("/v1/admin/akil/merkez/", { params: { gun }, timeout: 120000 }).then((r) => r.data);

export const akilMerkezKomut = (payload) =>
    api.post("/v1/admin/akil/merkez/komut/", payload, { timeout: 120000 }).then((r) => r.data);

export const akilMerkezOtonomRun = () =>
    api.post("/v1/admin/akil/merkez/otonom-run/", {}, { timeout: 180000 }).then((r) => r.data);

export const akilDosyaSaglik = (params = {}) =>
    api.get("/v1/admin/akil/merkez/dosya-saglik/", { params, timeout: 60000 }).then((r) => r.data);

export const akilTahkimDkPaket = (payload) =>
    api.post("/v1/admin/akil/tahkim-dk-paket/", payload, { timeout: 180000 }).then((r) => r.data);

export const akilSenaryoKarsilastir = (payload) =>
    api.post("/v1/admin/akil/senaryo-karsilastir/", payload, { timeout: 60000 }).then((r) => r.data);

export const akilBasvuruMetni = (payload) =>
    api.post("/v1/admin/akil/basvuru-metni/", payload, { timeout: 120000 }).then((r) => r.data);

export const akilMesajTaslagi = (payload) =>
    api.post("/v1/admin/akil/mesaj-taslagi/", payload, { timeout: 120000 }).then((r) => r.data);

export const akilWhatsappKuyruk = (payload) =>
    api.post("/v1/admin/akil/whatsapp-kuyruk/", payload, { timeout: 60000 }).then((r) => r.data);

export const akilEvrakDosyaGuncelle = (payload) =>
    api.post("/v1/admin/akil/evrak-dosya-guncelle/", payload, { timeout: 120000 }).then((r) => r.data);

export const akilSerbestSoru = (soru) =>
    api.post("/v1/admin/akil/sor/", { soru }, { timeout: 120000 }).then((r) => r.data);

export const akilDegerKaybiKaydet = (payload) =>
    api.post("/v1/admin/akil/deger-kaybi-kaydet/", payload, { timeout: 60000 }).then((r) => r.data);

export const akilIslemLoglari = (params = {}) =>
    api.get("/v1/admin/ai-loglari/", { params }).then((r) => r.data);

export const akilOgrenmeOzet = (gun = 30) =>
    api.get("/v1/admin/akil/ogrenme-ozeti/", { params: { gun } }).then((r) => r.data);

export const akilOgrenmeSync = (logLimit = 80) =>
    api.post("/v1/admin/akil/ogrenme-ozeti/", { log_limit: logLimit }).then((r) => r.data);

export const akilChatHistoryList = () =>
    api.get("/v1/admin/akil/sohbet/gecmis/").then((r) => r.data);

export const akilChatHistoryCreate = (baslik) =>
    api.post("/v1/admin/akil/sohbet/gecmis/", { baslik }).then((r) => r.data);

export const akilChatHistoryDetail = (id) =>
    api.get(`/v1/admin/akil/sohbet/gecmis/${id}/`).then((r) => r.data);

export const akilChatHistoryDelete = (id) =>
    api.delete(`/v1/admin/akil/sohbet/gecmis/${id}/`).then((r) => r.data);

export const akilStyleCorrection = (payload) =>
    api.post("/v1/admin/akil/stil-duzeltme/", payload).then((r) => r.data);

export const akilStyleProfile = () =>
    api.get("/v1/admin/akil/stil-profili/").then((r) => r.data);

export const akilHafizaSearch = (payload) =>
    api.post("/v1/admin/akil/hafiza/ara/", payload).then((r) => r.data);

export const akilHafizaCreate = (payload) =>
    api.post("/v1/admin/akil/hafiza/ekle/", payload).then((r) => r.data);

export const akilPredictOutcome = (dosyaId, params = {}) =>
    api.get("/v1/admin/akil/tahmin/", { params: { dosya_id: dosyaId, ...params }, timeout: 120000 }).then((r) => r.data);

export const akilDosyaIntel = (dosyaId, params = {}) =>
    api
        .get("/v1/admin/akil/dosya-intel/", {
            params: { dosya_id: dosyaId, ...params },
            timeout: 120000,
        })
        .then((r) => r.data);

export const akilDosyaIntelAction = (payload) =>
    api.post("/v1/admin/akil/dosya-intel/", payload, { timeout: 180000 }).then((r) => r.data);

export const akilRunHealthCheck = () =>
    api.post("/v1/admin/akil/saglik-tarama/").then((r) => r.data);

export const akilDosyaSaglikUyarilari = (params = {}) =>
    api.get("/v1/admin/akil/saglik-uyarilari/", { params }).then((r) => r.data);

export const akilAjanGorevleri = (params = {}) =>
    api.get("/v1/admin/akil/ajan-gorevleri/", { params }).then((r) => r.data);

export const akilAjanGoreviIslem = (payload) =>
    api.post("/v1/admin/akil/ajan-gorevleri/", payload).then((r) => r.data);

export const akilUltraServices = () =>
    api.get("/v1/admin/akil/merkez/ultra/").then((r) => r.data);

export const akilUltraServicesAction = (payload) =>
    api.post("/v1/admin/akil/merkez/ultra/", payload).then((r) => r.data);

export const akilSiteWidgetGet = (gun = 7) =>
    api.get("/v1/admin/akil/widget-site/", { params: { gun } }).then((r) => r.data);

export const akilSiteWidgetSave = (ayarlar) =>
    api.patch("/v1/admin/akil/widget-site/", { ayarlar }).then((r) => r.data);

